import {Controller} from "stimulus";

export default class extends Controller {
  static targets = ["workspace", "reminders", "contacts", "contactList", "contactDetail", "priorityQueue", "currentView", "view"];
  initialize() {
    history.scrollRestoration = "manual";
    document.addEventListener('dashboard.call.ended', event => {
      let dashboard = this.application.getControllerForElementAndIdentifier(document.getElementById('body'), 'dashboard');
      dashboard.showList();
    });
    document.addEventListener('filters.filtered', event => {
      let dashboard = this.application.getControllerForElementAndIdentifier(document.getElementById('body'), 'dashboard');
      dashboard.showList();
    });
    this.setActiveView();
  }

  get fetch_headers() {
    return { 'Accept' : 'application/json, text/html', 'Content-Type' : 'application/json', 'X-Requested-With' : 'XMLHttpRequest' };
  }

  fetch_response(response) {
    if (!response.ok) {
      throw Error(response.statusText);
    }
    return response.text();
  }

  showContact(e) {
    let url = '/concierge/contacts/' + e.currentTarget.dataset.id;
    fetch(url, {
      method: 'GET',
      headers: this.fetch_headers
    }).then(this.fetch_response)
      .then(html => {
        document.dispatchEvent(new CustomEvent('dashboard.detail.shown'));
        this.contactDetailTarget.innerHTML = html;
        this.contactListTarget.style.display = 'none';
        this.contactDetailTarget.style.display = 'block';
      }).catch(error => console.log(error));
  }

  removeContact(id) {

  }

  update(event, html) {
    if (html) {
      this.contactsTarget.innerHTML = html;
    }
    else {
      this.contactsTarget.innerHTML = '';
    }
    this.showList();
  }

  showList() {
    this.contactDetailTarget.style.display = 'none';
    this.contactListTarget.style.display = 'flex';
    document.dispatchEvent(new CustomEvent('dashboard.list.shown'));
  }

  setView(e) {
    if (!this.hasCurrentViewTarget) {
      return;
    }
    let view = e.currentTarget.dataset.view;
    this.currentViewTarget.dataset.view = view;
    document.dispatchEvent(new CustomEvent('pager.stop'));
    fetch('/concierge/contacts?v=' + view, {
      method: 'GET',
      headers: this.fetch_headers
    }).then(this.fetch_response)
      .then(html => {
        this.update(null, html);
        this.setActiveView();
        document.dispatchEvent(new CustomEvent('pager.reset'));
      });
  }

  showReminders() {
    for (let target of this.viewTargets) {
      target.classList.toggle("active", target.dataset.view === 'reminders');
    }
    this.workspaceTarget.style.display = 'none';
    this.remindersTarget.style.display = 'block';
  }

  setActiveView() {
    if (this.hasCurrentViewTarget) {
      let view = this.currentViewTarget.dataset.view;
      for (let target of this.viewTargets) {
        target.classList.toggle("active", target.dataset.view === view);
      }
    }
    this.workspaceTarget.style.display = 'block';
    this.remindersTarget.style.display = 'none';
  }

}